/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListEaiControlledDeviceIdsRequest = {
  agentId: string;
};

/** @internal */
export type ListEaiControlledDeviceIdsRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const ListEaiControlledDeviceIdsRequest$outboundSchema: z.ZodType<
  ListEaiControlledDeviceIdsRequest$Outbound,
  z.ZodTypeDef,
  ListEaiControlledDeviceIdsRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listEaiControlledDeviceIdsRequestToJSON(
  listEaiControlledDeviceIdsRequest: ListEaiControlledDeviceIdsRequest,
): string {
  return JSON.stringify(
    ListEaiControlledDeviceIdsRequest$outboundSchema.parse(
      listEaiControlledDeviceIdsRequest,
    ),
  );
}
